import {
    call, put, all, takeLatest, spawn, select,
} from 'redux-saga/effects';
import Api from '../services/ApiManager';
import notification from '../../helpers/notification';
import { execSaveRequest, Options } from './effects';
import { saveIntentActionType, deleteIntentActionType, IntentActionTypes, buildIntentActionType } from '../../model/intent/action';
import { deleteIntentAction, saveIntentAction } from '../actions/intentActions';

function* saveIntent(action: IntentActionTypes) {
    const options: Options = {
        payload: action.payload,
        successMessage: 'Intention sauvegardée avec succès'
    };
    yield call(execSaveRequest,
        Api.intents.create,
        Api.intents.update,
        saveIntentAction.success,
        saveIntentAction.failure,
        options);
}

function* deleteIntent(action: IntentActionTypes) {
    try {
        const botId = yield select(state => state.bot.selectedBot);
        yield call(Api.intents.delete, botId, action.payload as string);
        yield put(deleteIntentAction.success(action.payload as string));
        notification.sucess('Entité sauvegardée avec succès');
    } catch (error) {
        yield put(deleteIntentAction.failure());
        notification.error(
            'Une erreur est survenue, veuillez réessayez ultérieurement',
        );
    }
}

function* buildIntent(action: IntentActionTypes) {
    try {
      const botId = yield select(state => state.bot.selectedBot);
      const response = yield call(Api.build.intent, botId, action.payload as string);
      const type = response.headers['content-type'];
      // @ts-ignore
      const blob = new Blob([response.data], { type, encoding: 'UTF-8' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'build.txt';
      link.click();
    } catch (error) { }
  }

export function* startIntentsSagas() {
    yield all([
        takeLatest(saveIntentActionType.request, saveIntent),
        takeLatest(deleteIntentActionType.request, deleteIntent),
        takeLatest(buildIntentActionType, buildIntent),
    ]);
}